export const SYNCHRONIZE_ACCESSPOINT_REQUEST = "SYNCHRONIZE_ACCESSPOINT_REQUEST";
export const SYNCHRONIZE_ACCESSPOINT_SUCCESS = "SYNCHRONIZE_ACCESSPOINT_SUCCESS";
export const SYNCHRONIZE_ACCESSPOINT_FAILURE = "SYNCHRONIZE_ACCESSPOINT_FAILURE";

export const SYNCHRONIZE_USER_REQUEST = "SYNCHRONIZE_USER_REQUEST";
export const SYNCHRONIZE_USER_SUCCESS = "SYNCHRONIZE_USER_SUCCESS";
export const SYNCHRONIZE_USER_FAILURE = "SYNCHRONIZE_USER_FAILURE";

export const SYNCHRONIZE_ACCESSPOINT_USER_REQUEST = "SYNCHRONIZE_ACCESSPOINT_USER_REQUEST";
export const SYNCHRONIZE_ACCESSPOINT_USER_SUCCESS = "SYNCHRONIZE_ACCESSPOINT_USER_SUCCESS";
export const SYNCHRONIZE_ACCESSPOINT_USER_FAILURE = "SYNCHRONIZE_ACCESSPOINT_USER_FAILURE";

export const SYNCHRONIZE_SCHEDULES_REQUEST = "SYNCHRONIZE_SCHEDULES_REQUEST";
export const SYNCHRONIZE_SCHEDULES_SUCCESS = "SYNCHRONIZE_SCHEDULES_SUCCESS";
export const SYNCHRONIZE_SCHEDULES_FAILURE = "SYNCHRONIZE_SCHEDULES_FAILURE";